(function () {
  function initTabbedContent(widget) {
    var tabs = Array.prototype.slice.call(widget.querySelectorAll('.tabbed-content__tab'));
    var detailsList = Array.prototype.slice.call(widget.querySelectorAll('.tabbed-content__details'));

    function syncFromDetails(details) {
      var index = Number(details.getAttribute('data-index'));
      var tab = tabs[index];
      if (!tab) return;
      tab.setAttribute('aria-selected', details.open ? 'true' : 'false');
      tab.tabIndex = details.open ? 0 : -1;
      tab.classList.toggle('is-active', details.open);
    }

    function activate(index, focusTab) {
      detailsList.forEach(function (details, i) {
        details.open = i === index;
      });
      if (focusTab && tabs[index]) {
        tabs[index].focus();
      }
    }

    detailsList.forEach(function (details) {
      details.addEventListener('toggle', function () {
        syncFromDetails(details);
      });
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false);
      });

      tab.addEventListener('keydown', function (event) {
        var newIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            newIndex = (index + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            newIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = tabs.length - 1;
            break;
          case 'Enter':
          case ' ':
          case 'Spacebar':
            event.preventDefault();
            activate(index, true);
            return;
          default:
            return;
        }

        event.preventDefault();
        activate(newIndex, true);
      });
    });
  }

  var widgets = document.querySelectorAll('.tabbed-content__widget');
  widgets.forEach(initTabbedContent);
})();
